import React, { useRef, useEffect, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';
import { StyledFormControl } from 'apps/web_forms/components/Form/styles';
import FormPageHeader from 'apps/web_forms/components/FormPageHeader';
import FormElements from 'apps/web_forms/components/Form/FormElements';
import DMButton from 'apps/web_forms/components/commons/DMButton';
import { ModalTypes } from 'apps/web_forms/utils/constants';
import { setModal, resetModal, setSuccessfulAction } from 'apps/web_forms/slices/appSlice';

const Dispatch = ({ goBackUrl, selectedForm = {}, loading, form, submit, showNotificationBar, cleanup }) => {
  const formContext = useFormContext();
  const { dispatchAnswers, isSubmitting } = useGlobalSelector();
  const isRenderedOnce = useRef(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(dispatchAnswers).length > 0 && !isRenderedOnce) {
      for (const [key, value] of Object.entries(dispatchAnswers)) {
        register(key);
        setValue(key, value);
      }
      isRenderedOnce.current = true;
    }
  }, [dispatchAnswers]);

  const openDraftModal = () => {
    dispatch(
      setModal({
        type: ModalTypes.DRAFT_MODAL,
        extraProps: {
          saveDraft: (description) => {
            dispatch(setSuccessfulAction('saved'));
            submit('draft', description);
            dispatch(resetModal());
            cleanup();
          },
          setDraftModalOpen: () => {
            dispatch(resetModal());
          }
        },
      })
    );
  };

  const submitDispatch = useCallback(() => {
    dispatch(setSuccessfulAction('submitted'));
  }, []);

  return !loading && (
    <React.Fragment>
      <FormPageHeader
          sticky
          notificationBarShowing={showNotificationBar}
          title={selectedForm.title}
          description={selectedForm.description}
          goBackUrl={goBackUrl}
          isSubmitting={isSubmitting}
          renderToggleButton={false}
          renderRightButton={() => (
            <DMButton
              disabled={isSubmitting}
              filled
              type='submit'
              callbackMethod={submitDispatch}
            >
              Submit
            </DMButton>
          )}
          renderSecondaryRightButton={
            () => (
              <DMButton
                disabled={isSubmitting}
                callbackMethod={() => openDraftModal()}
              >
                Save As Draft
              </DMButton>
            )
          }
        />
        <StyledFormControl>
          <FormElements
            elements={form.inputList || []}
            getInput={form.getInput}
            dispatchInitialAnswers={form.dispatchInitialAnswers}
            formContext={formContext}
            formErrors={formContext.errors}
          />
        </StyledFormControl>
    </React.Fragment>
  );
};

export default Dispatch;